import { useState } from 'react';
import './App.css';
import Game from './components/Game';
import Startup from './components/Startup';
import { GameSetup, PlayerX, GameState, GameVersus, GamePlayer } from './utils';

function App() {
  const [gameSetup, setGameSetup] = useState<GameSetup>({
    mark: PlayerX,
    versus: 'cpu',
    score: {
      X: 0,
      O: 0,
      ties: 0,
    },
    started: false,
  });

  const [gameState, setGameState] = useState<GameState>({ status: 'playing', winner: undefined });

  const onPlayerSelectedHandler = (player: GamePlayer) => {
    setGameSetup((gameSetup) => ({
      ...gameSetup,
      mark: player,
    }));
  };

  const onStartGameHandler = (versus: GameVersus) => {
    setGameSetup((gameSetup) => ({
      ...gameSetup,
      versus,
      started: true,
    }));
  };

  return (
    <div className="App">
      <main>
        {/* <Result winner={gameState.winner} versus={gameSetup.versus} mark={gameSetup.mark}/> */}
        {!gameSetup.started &&
          <Startup
            selectedPlayer={gameSetup.mark}
            onPlayerSelected={onPlayerSelectedHandler}
            onStartGame={onStartGameHandler}
          />}
        {gameSetup.started && <Game setup={gameSetup} setGameSetup={setGameSetup} state={gameState} setGameState={setGameState} />}
      </main>
    </div>
  );
}

export default App;
